import { ButtonOutline, ButtonPrimary } from '@/components/Form';
import FormInput from '@/components/Form/FormInput';
import Modal from '@/components/Modal';
import { Heading, Paragraph } from '@/components/Typography';
import { useAmplifyMutation } from '@/hooks/useAmplifyMutation';
import { Box, Flex, Stack } from '@chakra-ui/react';
import { useState, type FC } from 'react';
import type { OTPVerifyStepProps } from './types';

const OTPVerifyStep: FC<OTPVerifyStepProps> = ({ onNext, onPrev  }) => {
  const [code, setCode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  /** React query mutation */
  const mutation = useAmplifyMutation<any, { code: string }>({
    method: 'post',
    apiName: 'v1',
    path: '/auth/2fa/verify',
    mutationOptions: {
      onSuccess: async () => {
        onNext();
      },
      onError: (e) => {
        setErrorMessage(e.response?.data?.user_message?.message);
        console.error(e);
      },
      onSettled: () => {
        setIsLoading(false);
      }
    },
  });

  const handleVerify = () => {
    if (!code) return;
    setIsLoading(true);
    mutation.mutate({ code });
  }

  return (
    <Modal
      disabled
      data-testid="modal_setup2fa_otpVerify"
      onClose={() => {}}
      isOpen
      noMaxHeight={true}
      maxWidth={'327px'}
      noHeader
      hasCloseButton={false}
    >
      <Stack spacing="24px">
        <Heading variant="Bold18" color="darkWillow">
          Pasang Autentikasi 2 Lapis
        </Heading>
        
        <Box>
          <Paragraph variant="Default14" color="shade03" mb="8px">
            Masukkan 6 digit kode yang muncul di Google authenticator.
          </Paragraph>
          <FormInput
            type="text"
            label="Masukkan Kode"
            value={code}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCode(e.target.value)}
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => setCode(e.target.value)}
            errorMessage={errorMessage}
          />
        </Box>
        
        <Flex gap="8px">
          <ButtonOutline width="100%" onClick={onPrev} type="button">
            Kembali
          </ButtonOutline>
          <ButtonPrimary
            width="100%"
            onClick={handleVerify}
            isDisabled={!code}
            isLoading={isLoading}
            loadingText="Selanjutnya"
          >
            Selanjutnya
          </ButtonPrimary>
        </Flex>
      </Stack>
    </Modal>
  )
}

export default OTPVerifyStep;
